<template>
  <LKRoadmapsFeedModalContainer
    v-if="isActive"
    :content-class="['LKPublicationsFormdataListModal', contentClass]"
    @close="close"
  >
    <h4 class="LKPublicationsFormdataListModal__title">
      {{ title }}
      <v-btn small icon @click="close()">
        <v-icon v-text="'mdi-close'" />
      </v-btn>
    </h4>

    <slot />
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import LKRoadmapsFeedModalContainer from '@/views/LKRoadmapsFeed/components/Modals/LKRoadmapsFeedModalContainer.vue'


export default {
  name: 'LKPublicationsFormdataListModal',
  components: {
    LKRoadmapsFeedModalContainer,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    contentClass: String,
  },
  data: () => ({
    isActive: false,
  }),
  methods: {
    open() {
      // ждем подгрузки стилей для анимации модалки
      setTimeout(() => { this.isActive = true }, 300)

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    close() {
      this.isActive = false
      this.resolve()
      this.resolve = null
      this.$emit('closed')
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKPublicationsFormdataListModal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  max-width: calc(100% - #{2 * $modal-padding});
  max-height: calc(100% - #{2 * $modal-padding});
  margin: $modal-padding;
  overflow: none;
  overflow-y: auto;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  &__title {
    display: flex;
    justify-content: space-between;
    padding: 12px;
  }
}
</style>
